import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SpinnerService } from '@core/services/spinner.service';
import { UserService } from '@core/services/user.service';
import { finalize } from 'rxjs';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-view-s11-contract',
  template: ``,
  styles: [``],
})
export class ViewS11ContractComponent implements OnInit {
  constructor(
    private userService: UserService,
    private route: ActivatedRoute,
    private spinner: SpinnerService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    if (!environment.production) {
      const s11DocumentNumber = this.route.snapshot.paramMap.get(
        'id',
      ) as string;
      try {
        this.spinner.show();
        this.userService
          .getViewUrlByType('s11-documents', s11DocumentNumber)
          .pipe(finalize(() => this.spinner.hide()))
          .subscribe({
            next: (res) => {
              const { pathname, search } = new URL(
                res.codium_memo_url,
              );
              this.router.navigateByUrl(pathname + search);
            },
            error: (error) => {
              this.router.navigate(['/']);
            },
          });
      } catch (error) {
        console.error(error);
      }
    }
  }
}
